import {
  GET_HAIR_DIAGNOSIS,
  SAVE_TEMPORARY_DIAGNOSIS_USER,
  SAVE_DIAGNOSIS_USER,
  GET_DIAGNOSIS_USER_PROFILE,
  GET_USER_DIAGNOSIS,
  RESET_USER_DIAGNOSIS,
  MAKE_USER_CURRENT,
  SAVE_NEW_SALON_VISIT,
} from '../constants';

/**
 * The reducer saves first level product references
 * and replaces the rest with slugs. For use case so far,
 * this takes care of circular references
 * since we are not using the data nested that deep.
 */

const resetCurrentStatus = users =>
  Object.keys(users).reduce(
    (obj, userId) => ({
      ...obj,
      [userId]: {
        ...users[userId],
        current: false,
      },
    }),
    {}
  );

export default (state = { users: {} }, action) => {
  switch (action.type) {
    case `${GET_HAIR_DIAGNOSIS}_PENDING`:
      return {
        ...state,
        // ローディング状態
        isFullFilled: false,
      };
    case `${GET_HAIR_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      const withFlattenedRanges = {
        ...data,
        questions: data.questions.map(question => ({
          ...question,
          answers: question.answers.map(
            answer =>
              answer.results
                ? { ...answer, results: answer.results.map(result => [result.contentType, result.slug]) }
                : answer
          ),
        })),
      };
      return {
        ...state,
        ...withFlattenedRanges,
        // ローディング状態
        isFullFilled: true,
      };
    }
    case `${GET_HAIR_DIAGNOSIS}_REJECTED`:
      return {
        ...state,
        // ローディング状態
        isFullFilled: false
      };
    case `${SAVE_TEMPORARY_DIAGNOSIS_USER}`: {
      const { diagnosisResults, temporary, id } = action.payload;
      return {
        ...state,
        users: {
          ...state.users,
          [temporary ? 'temporary' : id]: {
            diagnosisResults,
            id: temporary ? 'temporary' : id,
          },
        },
      };
    }
    case `${SAVE_DIAGNOSIS_USER}_PENDING`:
      return state;
    case `${SAVE_DIAGNOSIS_USER}_FULFILLED`: {
      const data = action.payload;
      const newState = { ...state.users };
      delete newState.temporary;
      newState[data.id] = data;
      return {
        ...state,
        users: newState,
      };
    }
    case `${SAVE_DIAGNOSIS_USER}_REJECTED`:
      return state;
    case `${GET_DIAGNOSIS_USER_PROFILE}_PENDING`:
      return state;
    case `${GET_DIAGNOSIS_USER_PROFILE}_FULFILLED`: {
      const data = action.payload;
      if (!data.success) {
        throw data;
      } else {
        return {
          ...state,
          users: {
            ...state.users,
            [data.id]: {
              ...data,
              current: true,
            },
          },
        };
      }
    }
    case `${GET_DIAGNOSIS_USER_PROFILE}_REJECTED`:
      return state;
    case `${GET_USER_DIAGNOSIS}_PENDING`:
      return state;
    case `${GET_USER_DIAGNOSIS}_FULFILLED`: {
      const data = action.payload;
      if (data.error) {
        throw data.error;
      } else {
        const newState = { ...state.users };
        delete newState.temporary;
        newState[data.id] = data;
        return {
          ...state,
          users: newState,
        };
      }
    }
    case `${GET_USER_DIAGNOSIS}_REJECTED`:
      return state;
    case `${RESET_USER_DIAGNOSIS}`: {
      return {
        ...state,
        users: {
          ...resetCurrentStatus(state.users),
        },
      };
    }
    case `${MAKE_USER_CURRENT}`: {
      const id = action.payload;
      return {
        ...state,
        users: {
          ...resetCurrentStatus(state.users),
          [id]: {
            ...state.users[id],
            current: true,
          },
        },
      };
    }
    case `${SAVE_NEW_SALON_VISIT}_PENDING`:
      return state;
    case `${SAVE_NEW_SALON_VISIT}_FULFILLED`: {
      const data = action.payload;
      if (!data.success) {
        throw data;
      } else {
        return {
          ...state,
          users: {
            [data.id]: {
              ...state.users[data.id],
              salonVisits: data.salonVisits,
            },
          },
        };
      }
    }
    case `${SAVE_NEW_SALON_VISIT}_REJECTED`:
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/hairDiagnosis.js